import DOMPurify from 'dompurify';

const RICH_HTML_SANITIZE_OPTIONS = {
  ADD_ATTR: ['style'],
  ADD_DATA_URI_TAGS: ['img'],
  ADD_TAGS: ['u'],
  RETURN_DOM: true,
};

function restrictInlineStylesToColors(root) {
  if (!root?.querySelectorAll) return;

  root.querySelectorAll('[style]').forEach((element) => {
    const { color, backgroundColor } = element.style;
    element.removeAttribute('style');
    if (color) {
      element.style.color = color;
    }
    if (backgroundColor) {
      element.style.backgroundColor = backgroundColor;
    }
  });
}

export function sanitizeRichHtml(html) {
  const root = DOMPurify.sanitize(html ?? '', RICH_HTML_SANITIZE_OPTIONS);
  restrictInlineStylesToColors(root);
  return root.innerHTML ?? '';
}
